import { css } from 'styled-components';

export const sliding = css`
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
`;

export const slideDown = css`
  ${sliding};
  visibility: visible;
  max-height: 1000px;
  display: block;
`;

export const slideUp = css`
  ${sliding};
  visibility: hidden;
  height: 0;
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
  opacity: 0;
  display: none;
`;
